import React from 'react';
import { Button,
         Container,
         FormControl,
         Grid,
         InputLabel,
         InputAdornment,
         Table,
         TableContainer,
         TableHead,
         TableRow,
         TableCell,
         TableBody,
         Typography,
         OutlinedInput } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { withStyles } from '@material-ui/core/styles';


const useStyles = theme => ({
  containerStyle: {
    padding: '10px',
  },
  buttonStyle: {
    margin: '10px',
    fontWeight: 'bold',
  },
  gridStyle: {
    marginTop: '10px',
    marginBottom: '10px',
  },
  textField: {
    width: '30ch',
  },
  tableHeading: {
    fontWeight: 'bold',
    fontSize: ''
  }
});

const rows = [
  {
    patientName: 'John Doe',
    caseType: 'Pulmonary',
    historyOfPresentIllness: 'Has some coughing',
    lastUpdated: 'About 4 hours ago',
  },
  {
    patientName: 'Mickey Mouse',
    caseType: 'Orthopedic',
    historyOfPresentIllness: 'Has some hamstring soreness',
    lastUpdated: 'About 4 hours ago',
  },
];


class MyCases extends React.Component {

  componentDidMount() {
    console.log('mounted the component');
  }

  render() {
    const { classes } = this.props;
    return (
      <Container className={classes.containerStyle}>
        <Grid container justify='space-between' alignItems='center' className={classes.gridStyle}>
          <FormControl fullWidth className={classes.textField} variant='outlined' size='small'>
            <InputLabel>Search</InputLabel>
            <OutlinedInput
              color='primary'
              labelWidth={50}
              startAdornment={<InputAdornment position='start'><SearchIcon color='disabled' /></InputAdornment>}
            />
          </FormControl>
          <Button
            onClick={() => {console.log('click')}}
            color='primary'
            variant='contained'
            size='large'
            className={classes.buttonStyle}
          >
            Add a new case
          </Button>
        </Grid>
        <TableContainer className={classes.gridStyle}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell className={classes.tableHeading}>
                  Patient Name
                </TableCell>
                <TableCell className={classes.tableHeading}>
                  Case Type
                </TableCell>
                <TableCell className={classes.tableHeading}>
                  History of Present Illness
                </TableCell>
                <TableCell className={classes.tableHeading}>
                  Last Updated
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row) => (
                <TableRow key={row.patientName}>
                  <TableCell>{row.patientName}</TableCell>
                  <TableCell>{row.caseType}</TableCell>
                  <TableCell>{row.historyOfPresentIllness}</TableCell>
                  <TableCell>{row.lastUpdated}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Container>
    );
  }
}

export default withStyles(useStyles)(MyCases)
